import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { defaultStorage } from 'aws-amplify/utils';

import { Config } from '../config';

const prefix = window.location.hostname.split('.')[0];
const env = prefix.startsWith('pr-') ? 'test' : prefix;

export const configureAmplify = async () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: Config.UserPoolID,
        userPoolClientId: Config.AppClientID, // Config.AppClientID,
        loginWith: {
          // Optional
          oauth: {
            domain: `hayden-${env}.auth.${Config.AWSRegion}.amazoncognito.com`,
            scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [`${window.location.origin}/oauth2/idpresponse`],
            redirectSignOut: [window.location.origin],
            responseType: 'code',
          },
        },
      },
    },
  });

  cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
};
